import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { EodIncidentReport } from './eod-incident-report.model';

interface CreateOrUpdateEodIncidentReportResponse {
  data: {
    eodIncidentReport: EodIncidentReport;
  };
}

@Injectable({
  providedIn: 'root'
})

export class IncidentReportService {

  constructor(private apiService: ApiService) {}


  async fetchById(id: string): Promise<EodIncidentReport> {
    try {
      const response = await this.apiService.get<CreateOrUpdateEodIncidentReportResponse>(`/eod-incident-report/${id}`);
      return response.data?.eodIncidentReport || {} as EodIncidentReport;
    } catch (error) {
      throw error;
    }
  }

  async create(eodIncidentReport: EodIncidentReport): Promise<EodIncidentReport> {
    try {
      const response = await this.apiService.post<CreateOrUpdateEodIncidentReportResponse>('/eod-incident-report', eodIncidentReport);
      return response.data?.eodIncidentReport;
    } catch (error) {
      throw error;
    }
  }

  async update(eodIncidentReport: EodIncidentReport): Promise<EodIncidentReport> {
    try {
      const response = await this.apiService.put<CreateOrUpdateEodIncidentReportResponse>(`/eod-incident-report/${eodIncidentReport.id}`, eodIncidentReport);
      return response.data?.eodIncidentReport;
    } catch (error) {
      throw error;
    }
  }

  async delete(id: string): Promise<void> {
    try {
      await this.apiService.delete(`/eod-incident-report/${id}`);
    } catch (error) {
      throw error;
    }
  }
}
